import React from 'react';
import { Card, CardContent, Typography, Box, Chip } from '@mui/material';

interface ProfileSkillsProps {
  skills?: any[];
}

export default function ProfileSkills({ skills }: ProfileSkillsProps) {
  if (!skills || skills.length === 0) return null;

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Skills
        </Typography>
        <Box display="flex" flexWrap="wrap" gap={1}>
          {skills.map((skill: any, index: number) => (
            <Chip 
              key={index} 
              label={typeof skill === 'string' ? skill : skill.skillName || skill.name || 'Unknown'} 
              variant="outlined"
              color={skill.isPrimarySkill ? 'primary' : 'default'}
              size="medium"
            />
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}